import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1ccce977"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "parents-card" }
const _hoisted_2 = {
  key: 0,
  class: "child-card"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Only the relationship will be deleted.", -1))

import { computed, ref } from 'vue'
import { AssertionType, ViewFamily } from '@/rd/ResearchDataModel'
import { useAssertionStore } from '@/rd/AssertionStore'
import { CompositeId } from '@/rd/CompositeId'
import { AsyncUtil } from '@/util/AsyncUtil'
import Modal from '@/util/Modal.vue'
import PersonCard from '@/manage/PersonCard.vue'
import FamilyCard from '@/manage/FamilyCard.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileChildRemoveModal',
  emits: [
  'removed',
],
  setup(__props, { expose: __expose, emit }) {

const assertionStore = useAssertionStore()

const childIdRef = ref<string>()
const parentFamilyRef = ref<ViewFamily>()
const removeParentsRef = ref(false)
const modalRef = ref<InstanceType<typeof Modal>>()

const titleRef = computed(() => removeParentsRef.value ? 'Remove parents' : 'Remove child')
const messageRef = computed(() => removeParentsRef.value 
  ? "Are you sure you want to remove the child's relationship to these parents?"
  : 'Are you sure you want to remove this child?')

__expose({
  open,
})



function open(childId: string, parentFamily: ViewFamily, removeParents = false) {
  childIdRef.value = childId
  parentFamilyRef.value = parentFamily
  removeParentsRef.value = removeParents
  modalRef.value?.open()
}

async function removeChild() {
  if (!childIdRef.value || !parentFamilyRef.value)
    throw 'Child or parent family not set'

  const profileGroupId = CompositeId.getGroupId(childIdRef.value)!
  const familyId = parentFamilyRef.value?.matchIds.find(id => CompositeId.hasGroupId(id, profileGroupId))
  if (!familyId)
    throw `Family match not found in profile ${profileGroupId}`

  const childAssertion = assertionStore.getLoadedForPerson(childIdRef.value)
    .find(a => a.assertionType == AssertionType.Child && parentFamilyRef.value?.matchIds.includes(a.relatedItemId!))
  if (!childAssertion)
    throw `Child assertion in ${childIdRef.value} not found for family ${parentFamilyRef.value.id}`

  await AsyncUtil.atLeast(500, assertionStore.deleteAsync(childAssertion.id!))

  emit('removed')

  modalRef.value?.close()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    ref_key: "modalRef",
    ref: modalRef,
    onOk: removeChild
  }, {
    title: _withCtx(() => [
      _createTextVNode(_toDisplayString(titleRef.value), 1)
    ]),
    okText: _withCtx(() => [
      _createTextVNode("Remove")
    ]),
    default: _withCtx(() => [
      _createElementVNode("p", null, _toDisplayString(messageRef.value), 1),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(FamilyCard, {
          "family-id": parentFamilyRef.value?.id,
          static: ""
        }, null, 8, ["family-id"])
      ]),
      (!removeParentsRef.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(PersonCard, {
              "person-id": childIdRef.value,
              layout: "small",
              "show-profile-type": "",
              "show-profile-count": "multiple",
              static: ""
            }, null, 8, ["person-id"])
          ]))
        : _createCommentVNode("", true),
      _hoisted_3
    ]),
    _: 1
  }, 512))
}
}

})